module.exports = __webpack_public_path__ + "static/Group 6974-fc07e5f4ee68ff697ce252b8598035b2.png";